import { render, staticRenderFns } from "./Imofalform6Grid.vue?vue&type=template&id=5ecde55c"
import script from "./Imofalform6Grid.vue?vue&type=script&lang=js"
export * from "./Imofalform6Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports